<script lang="ts">
	//Svelte hooks
	import { beforeUpdate } from 'svelte';
	//Services
	import { format } from 'svelte-i18n';
	//Helpers
	import { get_gen_2_component_channel_structure } from '../../../helpers/interface_helpers';
	import { setCuryAwayMode, getCuryModeState } from '../../../helpers/cury_mode_helpers';
	import { unlockPin } from '../../../helpers/pin_lock_helpers';
	import { hasControlRights } from 'src/helpers/user_helpers';
	//Stores
	import { pin_unlocked_devices } from 'src/stores/device-runtime/pin-unlocked';
	import { devices } from 'src/stores/lists/devices';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';
	//Design system components
	import { Text, Toggle, FlexibleCard } from '@Shelly/shelly-design-system';
	//Components
	import PinUnlock from '../../../components/PinUnlock.svelte';
	//Types
	import type { Device } from '../../../types/Device';
	import type { DeviceStatusG2 } from '../../../types/DeviceStatusG2';

	export let device: Device;
	export let status: DeviceStatusG2;
	export let title = $format('sub_settings_title_away_mode', { default: 'Away Mode' });
	export let isSidePanelOpen = true;

	const component = get_gen_2_component_channel_structure(device);

	$: hasRights = hasControlRights(device);

	let isRequestLoading = false;
	let isWaitingStatusChange = false;
	let startAwayMode = false;
	let stopAwayMode = false;
	let awayModeActive = false;
	let pinLocked = false;
	let showModal = false;

	beforeUpdate(() => {
		pinLocked =
			typeof $pin_unlocked_devices[device.id] === 'undefined' && $devices[device.id]?.pin_lock;

		const modeState = getCuryModeState(status, component);
		awayModeActive = modeState.away_mode;

		checkIsStatusChange();
	});

	const checkIsStatusChange = () => {
		if (isWaitingStatusChange && awayModeActive && startAwayMode) {
			isWaitingStatusChange = false;
			startAwayMode = false;
		} else if (isWaitingStatusChange && !awayModeActive && stopAwayMode) {
			isWaitingStatusChange = false;
			stopAwayMode = false;
		}
	};

	const onToggleBtn = () => {
		isWaitingStatusChange = true;

		if (awayModeActive) {
			stopAwayMode = true;
		} else {
			startAwayMode = true;
		}
	};

	const handleClick = async () => {
		if (!pinLocked) {
			isRequestLoading = true;
			onToggleBtn();
			await setCuryAwayMode(device, !awayModeActive);
			isRequestLoading = false;
		} else {
			showModal = true;
		}
	};

	const handlePin = () => {
		pinLocked = unlockPin(device, pinLocked);
		handleClick();
	};
</script>

<FlexibleCard
	class="d-flex justify-content-center align-items-center"
	backgroundColor={$showNewLayout ? '--color-0' : isSidePanelOpen ? '--color-0' : '--color-1'}
>
	<Text class="text-bold mt-s">{title}</Text>
	<Toggle
		id="toggle-away-mode"
		aria-label={$format('toggle_ambient', { default: 'Toggle Ambient' })}
		slot="right"
		size="m"
		class="mt-xs"
		loading={isRequestLoading}
		disabled={!hasRights}
		checked={awayModeActive}
		on:click={handleClick}
	/>
</FlexibleCard>
{#if showModal}
	<PinUnlock bind:showModal on:unlock={handlePin} on:cancel={() => (showModal = false)} />
{/if}
